import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "__barrel_optimize__?names=Flex,Skeleton,Typography!=!/root/iyiwutrade/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/(main)/rfq/index.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(main)/rfq/rfq.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/DataBoundary/index.js");
